import DepositoList from './DepositoList.vue'
export default DepositoList
